import React from 'react'
import FacetMultiSelect from '../BaseComponents/FacetMultiSelect'
import { FacetSelect } from '../BaseComponents/FacetSelect'
import ExperienceFacetSection from './ExperienceFacetSection'

const PhysicalFacetSection: React.FC = () => (
  <>
    <ExperienceFacetSection />
    <FacetMultiSelect
      source="settingFacets"
      facetCategory="productFilter"
      filterGroup="Setting"
    />
    <FacetSelect
      source="teambuildingCategoryFacet"
      facetCategory="productFilter"
      filterGroup="TeamBuildingCategory"
    />
    <FacetMultiSelect
      source="languageFacets"
      facetCategory="productFilter"
      filterGroup="Language"
    />
  </>
)

export default PhysicalFacetSection
